module.exports = __webpack_public_path__ + "img/cards-mobile.282a4690.png";